<template>
  <div id="app">
    <component :is='layout'>
      <router-view />
    </component>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      default_layout:'default'
    }
  },
  mounted(){
    console.log(this.$route.meta.layout,this.default_layout)
  },
  computed:{
    layout(){
      return (this.$route.meta.layout || this.default_layout) + '-layout'
    }
  }
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue